import axios from 'axios'
import {Message} from 'element-ui'
import router from '../router/index'

axios.interceptors.request.use(config => {
    return config
}, err => {
    Message.error({message: '请求超时!'})
    return Promise.resolve(err)
})
// 统一的错误参数处理
axios.interceptors.response.use(data => {
    return data
}, err => {
    let message = 'Sorry unknown err happened'
    switch (err.response.status) {
        case 504:
            message = 'Gateway err'
            break
        case 404:
            message = 'Not found'
            break
        case 403:
            message = 'Permission Denied'
            break
        case 401:
            message = 'Please reLogin'
            router.push('/')
            break
        case 500:
            message = 'The sever can not process the request'
            break
        case 400:
            message = ''
            break
    }
    if (message) {
        Message.error({message: message})
    } else {
        return Promise.reject(err.response)
    }
})
export default axios
